module.exports = __webpack_public_path__ + "img/iconview-gray.617e9384.svg";